import { Component, OnInit } from '@angular/core';
import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-base',
  templateUrl: './common-base.component.html',
  styleUrls: ['./common-base.component.scss']
})
export class CommonBaseComponent implements OnInit {

  rootScopeData: RootScopeDeclare;
  constructor(
    private rootScopeService: RootScopeService,
    private router: Router
  ) { 
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
  }

}
